import { API_URL } from '../../../../../actions/utilAction';
import { actionCreator,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrlForCustomAPI,
  downloadFilesOnAPICall,
  downloadFilesOnAPICallForEDI,
  extractDataFromObject,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
  downloaduploadedDocumentsOnAPICall,
} from '../../../../../actions/utilAction';

export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrlForCustomAPI,
  create_post_data,
  downloadFilesOnAPICall,
  showSuccessMessage,
  showErrorMessage,
  extractDataFromObject,
  API_URL,
  showWarningMessage,
  downloadFilesOnAPICallForEDI,
  downloaduploadedDocumentsOnAPICall,
};


export const BILLING_CLAIMS = `${API_URL}/Claim`;// ?page[size]=10
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const GET_CLAIMS_WITH_SERVICE_LINES_FORPAYER_API = `${API_URL}/api/Payment/GetAllClaimsWithServiceLinesForPayer`;
export const POST_APPLY_PAYMENT_API = `${API_URL}/api/Payment/ApplyPayment`;
export const PAPER_CLAIM_API = `${API_URL}/api/PaperClaim/PaperClaim`;
export const RESUBMIT_CLAIM_API = `${API_URL}/EDI/ResubmitClaim`;
export const GET_PROCESSED_CLAIMS_API = `${API_URL}/EDIParser/GetProcessedClaims`;
export const GET_UNMAPPED_CLAIMS_API = `${API_URL}/EDIParser/GetUnmappedClaims`;
export const GET_PATIENT = `${API_URL}/api/PatientAppointments/GetStaffAndPatientByLocation`;
export const GET_PATIENT_GUARANTOR = `${API_URL}/patients/GetPatientGuarantor`;
export const GET_SERVICE_LOCATIONS_API = `${API_URL}/api/PatientAppointments/GetDataForSchedulerByPatient`;
export const GET_SERVICELINE_DETAILS_API = `${API_URL}/Claim/GetClaimServiceLineDetail`;
//export const EDI837_SINGLECLAIM_API = `${API_URL}/EDI/DownloadSingleEDI837`;
export const EDI837_SINGLECLAIM_API = `${API_URL}/EDI/GenerateSingleEDI837`;
export const EDI837_BATCHCLAIM_API = `${API_URL}/EDI/GenerateBatchEDI837`;
export const EDI837_BATCHRESUBMITCLAIM_API = `${API_URL}/EDI/ResubmitBatchEDI837`;
export const PAPER_CLAIM_API_SECONDARY = `${API_URL}/api/PaperClaim/PaperClaim_Secondary`;
export const EDI837_SECONDARY_API = `${API_URL}/EDI/GenerateSingleEDI837_Secondary`;
export const EDI837_BATCH_CLAIM_SECONDARY_API = `${API_URL}/EDI/GenerateBatchEDI837_Secondary`;
export const DOWNLOADEDI837_BATCH_CLAIM_API = `${API_URL}/EDI/DownloadBatchEDI837`;
export const DOWNLOADRESUBMITEDI837_BATCH_CLAIM_API = `${API_URL}/EDI/DownloadResubmitBatchEDI837`;
export const DOWNLOADSECONDARY837_BATCH_CLAIM_API = `${API_URL}/EDI/DownloadBatchEDI837_Secondary`;
export const DOWNLOADEDIENCOUNTERS_BATCH_CLAIM_API = `${API_URL}/EDI/DownloadBatchEDIEncountersClaims`;
//export const SUBMITCLAIMSFORNONEDI_API = `${API_URL}/EDI/SubmitClaimsForNonEDI`;
export const SUBMITCLAIMSFORNONEDI_API = `${API_URL}/EDI/SubmitClaimsToNonEDIPayers`;
export const RENDER_AUTO_COMPLETE_MUI = `${API_URL}/api/MasterData/GetAutoComplateSearchingValues`; // MUI autocomplete]
export const PARSEEDI835_FROMCLEARINGHOUSE = `${API_URL}/EDIParser/ReadEDI835`;
export const GET_ALL_PAYER_SERVICE_CODES = `${API_URL}/Payer/GetPayerServiceCodesByPayerId`;
export const GET_PAYER_SERVICECODE_BY_ID = `${API_URL}/api/PayerServiceCodes/GetPayerServiceCodeById`;
//export const GET_PAYER_SERVICE_CODES_API = `${API_URL}/patients/GetPatientPayerServiceCodes`;
export const GET_PAYER_SERVICE_CODES_API = `${API_URL}/patients/GetPatientPayerServiceCodesAndModifiers`;
export const DELETE_CLAIM = `${API_URL}/Claim/DeleteClaim`;
export const BATCHPAPER_CLAIM_API = `${API_URL}/api/PaperClaim/BatchPaperClaim`;
export const BATCHPAPER_CLAIM_FORSECONDARYPAYER_API = `${API_URL}/api/PaperClaim/BatchPaperClaimForSecondaryPayer`;
export const POST_CLAIM_INTERNAL_NOTES_API = `${API_URL}/api/ClaimInternalNotes/SaveClaimInternalNote`;
export const GET_CLAIM_INTERNAL_NOTES_API = `${API_URL}/api/ClaimInternalNotes/GetClaimInternalNotes`;
export const DELETE_CLAIM_INTERNAL_NOTES_API = `${API_URL}/api/ClaimInternalNotes/DeleteClaimInternalNote`;
export const CHANGE_CLAIM_STATUS = `${API_URL}/Claim/UpdateClaimStatus`;
export const SAVE_NOTES_BULK_API = `${API_URL}/api/ClaimInternalNotes/SaveBatchClaimInternalNotes`;
export const GET_EDI835_FILE_API = `${API_URL}/EDIParser/GetEDI835File`;
export const UPDATEBATCHCLAIMSRENDERINGPROVIDER_CLAIM_API = `${API_URL}/Claim/UpdateBatchClaimsRenderingProvider`;
export const PARSEEDI835_FROMCLEARINGHOUSE_MASTERACCOUNT = `${API_URL}/EDIParser/ReadEDI835FromMasterAccount`;
export const EVV_BATCHCLAIM_API = `${API_URL}/EVV/GenerateBatchEVV`;
export const PARSEEVVRESPONSE_FROMTELLUS = `${API_URL}/EVV/ReadEVVResponse`;
export const GET_PROCESSED_EVVCLAIMS_API = `${API_URL}/EVV/GetProcessedEVVClaims`;
export const GET_EVV_FILE_API = `${API_URL}/EVV/GetEVVFile`;
export const DELETE_BATCH_APPLIED_PAYMENTS_API = `${API_URL}/Claim/DeleteBatchAppliedPayments`;
export const PARSEEDI999_FROMCLEARINGHOUSE = `${API_URL}/EDIParser/ReadEDI999`;

export const GET_OAACKNOWLEDGEMENT_CLAIMS_API = `${API_URL}/EDIParser/GetOAAcknowledgement`;
export const GET_OAANDPAYERRESPONSE_CLAIMS_API = `${API_URL}/EDIParser/GetOAandPayerResponseClaims`;
export const UPDATEBATCHRATEFORSERVICECODES_CLAIM_API = `${API_URL}/Claim/UpdateBatchRateForServiceCodes`;

export const POST_BATCH_PAYMENT_DETAILS_API = `${API_URL}/api/Payment/SaveBatchServiceLinePayment`;
export const GET_PAYMENT_DETAILS_API = `${API_URL}/api/Payment/GetPaymentDetailsById`;
export const POST_PAYMENT_DETAILS_API = `${API_URL}/api/Payment/SaveServiceLinePayment`;

export const BULK_UPDATE_WRITE_OFF_DATE_API = `${API_URL}/Claim/UpdateBulkCloseOrWriteOffDate`;
export const GET_LEDGER_DETAILS_API = `${API_URL}/Claim/GetClaimsForLedger`;
export const GETALLSECONDARYPAYER = `${API_URL}/EDI/GetAllSecondayerPayer`;

export const BillingActionTypes = {
  get_master_data: createRequestActionTypes('GET_MASTER_DATA'),
  get_claim_master_data: createRequestActionTypes('GET_CLAIM_MASTER_DATA'),
  get_claims_BySearchText: createRequestActionTypes('GET_CLAIMS_BYSEARCHTEXT'),
  get_claims: createRequestActionTypes('GET_CLAIMS'),
  get_AllClaimsWithServiceLines: createRequestActionTypes('GET_ALLCLAIMSWITHSERVICELINES'),
  get_claim_history: createRequestActionTypes('GET_CLAIM_HISTORY'),
  get_ClaimServiceLines_ByClaimId: createRequestActionTypes('GET_CLAIMSERVICELINES_BYCLAIMID'),
  delete_ServiceCode_FromClaim: createRequestActionTypes('DELETE_SERVICECODE_FROMCLAIM'),
  Post_ServiceCode_ForClaim: createRequestActionTypes('POST_SERVICECODE_FORCLAIM'),
  get_ClaimDetails_ByClaimId: createRequestActionTypes('GET_CLAIMDETAILS_BYCLAIMID'),
  update_Claim_Detials: createRequestActionTypes('UPDATE_CLAIM_DETAILS'),
  get_PatientEncounterDetails_ByEncounterId: createRequestActionTypes('GET_PATIENTENCOUNTERDETAILS_BYENCOUNTERID'),
  get_PayerByPatientId: createRequestActionTypes('GET_PAYERBYPATIENTID'),
  get_SubmitClaim: createRequestActionTypes('GET_SUBMITCLAIM'),
  get_AllClaimsWithServiceLinesForPayer: createRequestActionTypes('GET_CLAIMS_WITH_SERVICE_LINES_FORPAYER'),
  post_apply_payment: createRequestActionTypes('POST_APPLY_PAYMENT'),
  get_processed_claim: createRequestActionTypes('GET_PROCESSED_CLAIMS'),
  get_unmapped_claim: createRequestActionTypes('GET_UNMAPPED_CLAIMS'),
  get_patient: createRequestActionTypes('GET_PATIENT'),
  get_patient_guarantor: createRequestActionTypes('GET_PATIENT_GUARANTOR'),
  get_patient_serviceLocations: createRequestActionTypes('GET_PATIENT_SERVICELOCATIONS'),
  get_claimServiceLineDetails: createRequestActionTypes('GET_CLAIM_SERVICELINE_DETAILS'),
  get_SubmitClaim_EDI837: createRequestActionTypes('GET_SUBMITCLAIM_EDI837'),
  get_SubmitBatchClaim_EDI837: createRequestActionTypes('GET_SUBMITBATCHCLAIM_EDI837'),
  get_SubmitClaimsForNonEDI: createRequestActionTypes('GET_SUBMITCLAIMSFORNONEDI'),
  get_ResubmitClaim: createRequestActionTypes('RESUBMIT_CLAIM_API'),
  get_autocomplete_mui: createRequestActionTypes('RENDER_AUTO_COMPLETE_MUI'),
  get_EDI837_secondary: createRequestActionTypes('EDI837_SECONDARY_API'),
  get_ParseEDI835FromClearingHouse: createRequestActionTypes('PARSEEDI835_FROMCLEARINGHOUSE'),
  get_EDI837_Batch_Claim_secondary: createRequestActionTypes('EDI837_BATCH_CLAIM_SECONDARY_API'),
  get_Paper_Claim_secondary: createRequestActionTypes('PAPER_CLAIM_API_SECONDARY'),
  get_all_payer_cpt_codes_by_payer: createRequestActionTypes('GET_ALL_PAYER_CPT_CODE_BY_PAYER'),
  get_payer_servicecode_by_Id: createRequestActionTypes('GET_PAYER_SERVICECODE_BY_ID'),  
  delete_Claim: createRequestActionTypes('DELETE_CLAIM'),
  get_ResubmitBatchClaim_EDI837: createRequestActionTypes('GET_RESUBMITBATCHCLAIM_EDI837'),  
  post_ResubmitBatchClaim_EDI837: createRequestActionTypes('POST_RESUBMITBATCHCLAIM_EDI837'),  
  get_ParseEDI835_FromClearingHouse: createRequestActionTypes('GET_PARSEEDI835_FROMCLEARINGHOUSE'),  
  get_SubmitBatchClaim: createRequestActionTypes('GET_SUBMITBATCHCLAIM'), 
  get_SubmitBatchClaim_SecondaryPayer: createRequestActionTypes('GET_SUBMITBATCHCLAIM_SecondaryPayer'), 
  Post_Claim_Internal_Notes: createRequestActionTypes('POST_CLAIM_INTERNAL_NOTES'),  
  Get_Claim_Internal_Notes: createRequestActionTypes('GET_CLAIM_INTERNAL_NOTES'),
  Delete_Claim_Internal_Notes: createRequestActionTypes('DELETE_CLAIM_INTERNAL_NOTES'),  
  change_Claim_Status: createRequestActionTypes('CLAIM_CHANGE_CLAIMS_STATUS'),  
  save_NotesBulk: createRequestActionTypes('SAVE_NOTES_BULK'),
  get_edi835_file: createRequestActionTypes('GET_EDI835_FILE_API'),
  patch_UpdateBatchCLaimRenderingProvider_Claim: createRequestActionTypes('UPDATEBATCHCLAIMRENDERINGPROVIDER_CLAIM_API'),
  get_ParseEDI835_FromClearingHouse_MasterAccount: createRequestActionTypes('GET_PARSEEDI835_FROMCLEARINGHOUSE_MASTERACCOUNT'), 
  get_SubmitBatchClaim_EVV: createRequestActionTypes('GET_SUBMITBATCHCLAIM_EVV'),
  get_download_batch_EDI: createRequestActionTypes('EDI837_BATCH_CLAIM_API'),
  get_ParseEVVResponse_FromTellus: createRequestActionTypes('GET_PARSEEVVRESPONSE_FROMTELLUS'),  
  get_processed_evvclaim: createRequestActionTypes('GET_PROCESSED_EVVCLAIMS'),
  get_evv_file: createRequestActionTypes('GET_EVV_FILE_API'),
  get_AppliedPaymentDetails: createRequestActionTypes('GET_APPLIEDPAYMENTDETAILS'),
  delete_BatchAppliedPayments: createRequestActionTypes('DELETE_BATCH_APPLIED_PAYMENTS_API'),
  get_ParseEDI999_FromClearingHouse: createRequestActionTypes('GET_PARSEEDI999_FROMCLEARINGHOUSE'),  
  get_oaacknowledgement_claim: createRequestActionTypes('GET_OAACKNOWLEDGEMENT_CLAIMS'),
  get_oaandpayerresponse_claim: createRequestActionTypes('GET_OAANDPAYERRESPONSE_CLAIMS'),
  patch_UpdateBatchRateForServiceCodes_Claim: createRequestActionTypes('UPDATEBATCHRATEFORSERVICECODES_CLAIM_API'),
  post_batchPaymentDetails: createRequestActionTypes('POST_BATCH_PAYMENT_DETAILS'),
  get_paymentDetails: createRequestActionTypes('GET_PAYMENT_DETAILS'),
  post_paymentDetails: createRequestActionTypes('POST_PAYMENT_DETAILS'),
  bulkUpdateWriteOffDate: createRequestActionTypes('BULK_UPDATE_WRITE_OFF_DATE'),
  get_ledgerDetails: createRequestActionTypes('GET_LEDGER_DETAILS'),
  getEVVClientName:createRequestActionTypes('GETEVVCLIENTNAME'),
  getAllSecondaryPayer: createRequestActionTypes('GETALLSECONDARYPAYER'),
  get_Iscalled_FromERAMoule_Flag:createRequestActionTypes('GET_IS_CALLED_FROM_ERA_MODULE_FLAG')
};



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/constants/ApiConstants.js